import Vue from 'vue'

Vue.mixin({
    computed: {
        appUrl () {
            return process.env.appUrl
        },
        contributorsUrl () {
            return process.env.contributorsUrl
        },
        assetsUrl () {
            return process.env.assetsUrl
        },
        notificationEmail () {
            return process.env.notificationEmail
        }
    }
})
